// extracted by mini-css-extract-plugin
export default {"userList":"TeamItem_userList__n5BZn"};